import React from "react";
import { useObserver } from "mobx-react-lite";
import { useHistory, useParams } from "react-router";
import { Grid, IconButton, Tabs, Tab, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import { DestinationStoreProvider } from "./DestinationStore";
import { ChurnSegmentStoreProvider } from "./ChurnSegmentStore";
import { ChurnSegmentFormStoreProvider } from "./ChurnSegmentFormStore";
import Destination from "./Destination";
import ChurnSegment from "./ChurnSegment";

const useStyles = makeStyles((theme) => ({
  hidden: {
    display: "none",
  },
}));

interface Params {
  agencyId: string;
  appId: string;
}

export const Page = () => {
  const [tab, setTab] = React.useState(0);
  const history = useHistory();
  const params = useParams<Params>();
  const styles = useStyles();

  const handleTab = React.useCallback((_, tab: number) => setTab(tab), []);

  return useObserver(() => (
    <Grid container spacing={2} justify="space-between" alignItems="center">
      <Grid item xs="auto">
        <IconButton color="primary" onClick={history.goBack}>
          <ArrowBackIcon />
        </IconButton>
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Tabs indicatorColor="primary" onChange={handleTab} value={tab}>
            <Tab label="レポート" />
            <Tab label="セグメント" />
          </Tabs>
          <Destination
            className={tab === 0 ? undefined : styles.hidden}
            agencyId={+params.agencyId}
            appId={+params.appId}
          />
          <ChurnSegment
            className={tab === 1 ? undefined : styles.hidden}
            agencyId={+params.agencyId}
            appId={+params.appId}
          />
        </Paper>
      </Grid>
    </Grid>
  ));
};

export default () => (
  <DestinationStoreProvider>
    <ChurnSegmentStoreProvider>
      <ChurnSegmentFormStoreProvider>
        <Page />
      </ChurnSegmentFormStoreProvider>
    </ChurnSegmentStoreProvider>
  </DestinationStoreProvider>
);
